import { useQuery } from "@tanstack/react-query";

import { getJobDetails } from "../services/job.services";
import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { GetJobDetailsResponse } from "../types/job.types";

export const useGetJobDetails = (id: number | string | undefined) => {
  const { data, isLoading, isError, error, refetch } = useQuery<GetJobDetailsResponse>({
    queryKey: GO_HIRE_QUERY_KEYS.jobDetails(id as string | number),
    queryFn: () => getJobDetails(id!),
    enabled: !!id,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
